import type { ReactNode } from 'react';
import { useTheme } from '../context/ThemeProvider';
import type { SortDirection } from '../hooks/useTableSort';
import styles from './GlobalSortableTh.module.css';

type GlobalSortableThProps<K extends string> = {
  sortKey: K;
  activeKey: K;
  direction: SortDirection;
  onSort: (key: K) => void;
  children: ReactNode;
  className?: string;
};

export function GlobalSortableTh<K extends string>({
  sortKey,
  activeKey,
  direction,
  onSort,
  children,
  className = '',
}: GlobalSortableThProps<K>) {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  const isActive = sortKey === activeKey;
  const iconSrc = isDarkMode
    ? '/assets/icons/chevron.down.svg'
    : '/assets/icons/chevron.down.black.svg';

  const ariaSort = isActive
    ? direction === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none';

  return (
    <th className={className} scope="col" aria-sort={ariaSort}>
      <button type="button" className={styles.sortButton} onClick={() => onSort(sortKey)}>
        <span>{children}</span>
        <span className={styles.icons} aria-hidden>
          <img
            src={iconSrc}
            alt=""
            width={8}
            height={5}
            className={`${styles.icon} ${styles.iconUp} ${isActive && direction === 'asc' ? styles.iconActive : ''}`}
          />
          <img
            src={iconSrc}
            alt=""
            width={8}
            height={5}
            className={`${styles.icon} ${isActive && direction === 'desc' ? styles.iconActive : ''}`}
          />
        </span>
      </button>
    </th>
  );
}
